import AT from '../constants/action-types';

const initialState = {
  authUser: null
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_USER_PROFILE_DONE:
      return { ...state, authUser: action.data.user };
    default:
      return state;
  }
}
